export const loadingSkeleton = (width: number | string) => (
  <div className={`h-2 ${width} animate-pulse rounded-[5px] bg-brightGray`} />
);

export const tooltipClassName = (enabled: boolean) =>
  enabled ? 'text-black' : 'text-spanishGray';